import api from '@/services/Api'

// ----------------------------- o

const namespaced = true;

// ----------------------------- o

const state = {
    errors: {},
    loading: false,
    data: [],
    single: {},
    page: 1,
    last_page: 1
};

// ----------------------------- o

const getters = {

};

// ----------------------------- o

const actions = {
    'USER_EMPLOYEES_REQUEST': ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit('USER_EMPLOYEES_REQUEST');
            let url = 'users/employees?page=' + state.page;
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('USER_EMPLOYEES_REQUEST_SUCCESS');
                    commit('USER_UPDATE_EMPLOYEES', resp.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('USER_EMPLOYEES_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'USER_EMPLOYEE_SINGLE_REQUEST': ({commit, dispatch}, employee_slug) => {
        return new Promise((resolve, reject) => {
            commit('USER_EMPLOYEES_REQUEST');
            let url = 'users/employees/'+employee_slug+'/details';
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('USER_EMPLOYEE_SET_SINGLE', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('USER_EMPLOYEES_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'USER_EMPLOYEE_VERIFY_REQUEST': ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit('USER_EMPLOYEES_REQUEST');
            let url = 'users/employees/'+payload.employee_slug+'/verify';
            let data = { 'place_slug': payload.place_slug };
            api({url: url, data: data, method: 'POST'})
                .then(resp => {
                    commit('USER_EMPLOYEES_REQUEST_SUCCESS');
                    dispatch('USER_EMPLOYEE_SINGLE_REQUEST', payload.employee_slug);
                    resolve(resp)
                })
                .catch(err => {
                    commit('USER_EMPLOYEES_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'USER_EMPLOYEE_UPDATE_REQUEST': ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit('USER_EMPLOYEES_REQUEST');
            let url = 'users/employees/'+payload.employee_slug+'/update';
            api({url: url, data: payload.data, method: 'POST'})
                .then(resp => {
                    commit('USER_EMPLOYEES_REQUEST_SUCCESS');
                    dispatch('USER_EMPLOYEE_SINGLE_REQUEST', payload.employee_slug);
                    resolve(resp)
                })
                .catch(err => {
                    commit('USER_EMPLOYEES_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'USER_EMPLOYEE_DELETE_REQUEST': ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit('USER_EMPLOYEES_REQUEST');
            console.log(payload);
            let url = 'users/employees/'+payload.employee_slug+'/delete';
            let data = { 'place_slug': payload.place_slug };
            api({url: url, data: data, method: 'POST'})
                .then(resp => {
                    commit('USER_EMPLOYEES_REQUEST_SUCCESS');
                    //dispatch('USER_EMPLOYEE_SINGLE_REQUEST', payload.employee_slug);
                    resolve(resp)
                })
                .catch(err => {
                    commit('USER_EMPLOYEES_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'USER_EMPLOYEES_SET_PAGE': ({commit, dispatch}, reset) => {
        return new Promise((resolve, reject) => {
            commit('USER_EMPLOYEES_SET_PAGE', reset);
            resolve();
        })
    },
};

// ----------------------------- o

const mutations = {
    'USER_EMPLOYEES_REQUEST': (state) => {
        state.errors = {};
        state.loading = true;
    },
    'USER_EMPLOYEES_REQUEST_SUCCESS': (state) => {
        state.errors = {};
        state.loading = false;
    },
    'USER_UPDATE_EMPLOYEES': (state, resp) => {
        state.last_page = resp.last_page;
        state.loading = false;
        // clear array or concat
        if (resp.data.length === 0) {
            state.data = [];
        } else {
            state.data = state.page > 1 ? state.data.concat(resp.data) : resp.data;
        }
    },
    'USER_EMPLOYEE_SET_SINGLE': (state, data) => {
        state.single = data;
        state.loading = false;
    },
    'USER_EMPLOYEES_ERROR': (state, resp) => {
        state.errors = resp;
        state.loading = false;
    },
    'USER_EMPLOYEES_SET_PAGE': (state, reset) => {
        state.page = reset ? state.page = 1 : state.page + 1;
    },
};

// ----------------------------- o

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations,
}
